/**
 * #670 — Nexus 저장소 좌표. 소스에 공인 IP 하드코딩 금지.
 * VITE_NEXUS_URL 빌드타임 주입(미주입 시 교체용 placeholder 도메인).
 * 선례: _index/data/monitoringEndpoints.ts(데이터 모듈 · env 승격 대비) +
 *       VITE_API_BASE ?? '/api/eraf' 폴백 관례(전 feature api 클라이언트).
 */
export const NEXUS_PUBLIC_URL =
  import.meta.env.VITE_NEXUS_URL ?? 'https://nexus.your-domain.example/repository/maven-public/';

/** placeholder(자사 좌표 미주입) 여부 — UI 가 '자사 Nexus 로 교체' 안내 배지 판단. */
export const NEXUS_IS_PLACEHOLDER = !import.meta.env.VITE_NEXUS_URL;
